import React from 'react'
import Link from 'gatsby-link'

const host = 'https://www.plusuno.jp'
const appPath = 'podcast-plus1'
const navList = [
  { title: "Privacy Policy", path: `${host}/${appPath}/privacy` },
  { title: "Support", path: `/contact`, relative: true },
]

const FooterNavList = (props) => (
  <div
    style={{
      background: 'white',
      marginBottom: '1.45rem',
      display: 'flex',
      justifyContent: 'flex-end'
    }}
  >
    <ul style={{
      display: 'flex',
      listStyle: 'none'
    }}>
      {props.children}
    </ul>
  </div>
)
const FooterNavListItem = (props) => (
  <li>
    <a
      href={props.path}
      style={{
        padding: 20,
      }}
    >
      {props.title}
    </a>
  </li>
)

const Footer = () => (
  <footer
    style={{
      backgroundColor: 'rgba(255,255,255,0.8)',
    }}
  >
    <FooterNavList>
      { navList.map((nav, index) => (
        <FooterNavListItem {...nav} key={index} />
      ))}
    </FooterNavList>
  </footer>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/index.js